export const checkLoginResponse = ({ message }) => {
  if (message !== 'success') {
    return false;
  }

  return true;
};
